var map = {
	"./icon-type-0.png": 96213,
	"./icon-type-1.png": 84588,
	"./icon-type-2.png": 51623,
	"./icon-type-254.png": 57828,
	"./icon-type-3.png": 75838,
	"./icon-type-undefined.png": 60997
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24266;